import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return true;
  }

  if (auth.hasExpiredSession()) {
    auth.logout({ redirectToLogin: true, reason: 'session-expired' });
    return false;
  }

  return router.parseUrl(auth.getDefaultRouteForRole());
};
